function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import includes from 'lodash/includes';
import { AppContext } from 'context';
import App from 'modules/App';
import * as constants from '../../constants';
import * as selectors from '../../selectors';
import * as shapes from '../../shapes';
import messages from '../../messages';
import styles from './SupportedPlatforms.pcss';
var _React_PureComponent;
class SupportedPlatforms extends (_React_PureComponent = React.PureComponent) {
    get platforms() {
        const platforms = [];
        constants.SUPPORTED_PLATFORMS.forEach((key)=>{
            const app = constants.APPS[key];
            const platform = _object_spread({}, app || constants.OTHER_PLATFORMS[key]);
            if (platform) {
                if (platform.url) {
                    platform.target = '_blank';
                } else if (app && this.bls[app.key]) {
                    platform.url = this.bls[app.key];
                }
                platforms.push(platform);
            }
        });
        return platforms;
    }
    getPlatformPurpose(platform) {
        let isBusinessPlatform = false;
        let isPrivatePlatform = false;
        for(let i = 0; i < platform.scopes.length; i++){
            if (includes([
                constants.SCOPE_NAMES.PROFESSIONAL,
                constants.SCOPE_NAMES.CLINIC_STAFF
            ], platform.scopes[i])) {
                isBusinessPlatform = true;
            }
            if (includes([
                constants.SCOPE_NAMES.PERSONAL,
                constants.SCOPE_NAMES.CAREGIVER
            ], platform.scopes[i])) {
                isPrivatePlatform = true;
            }
        }
        return {
            isBusinessPlatform,
            isPrivatePlatform
        };
    }
    getInfoMessage(platform) {
        const { isBusinessPlatform, isPrivatePlatform } = this.getPlatformPurpose(platform);
        if (isBusinessPlatform && isPrivatePlatform) {
            return messages.platformInfos.businessAndPrivate;
        }
        if (isBusinessPlatform) {
            return messages.platformInfos.business;
        }
        return messages.platformInfos.private;
    }
    renderSupportedPlatform(platform) {
        const message = this.getInfoMessage(platform);
        return /*#__PURE__*/ _jsxs("a", {
            className: styles.platform,
            href: platform.url,
            target: platform.target,
            children: [
                /*#__PURE__*/ _jsx("figure", {
                    className: styles.platform__logoContainer,
                    children: /*#__PURE__*/ _jsx("img", {
                        src: `/aid/assets/apps/${platform.image}`,
                        alt: platform.identityProviderType
                    })
                }),
                /*#__PURE__*/ _jsx("p", {
                    className: "text--base text--normal text--base-color text--bold text-lh--15 mb-2",
                    children: platform.name
                }),
                /*#__PURE__*/ _jsx("p", {
                    className: "text--small text--normal text--muted text-lh--15",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, message))
                })
            ]
        }, platform.key);
    }
    render() {
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.root,
            children: [
                /*#__PURE__*/ _jsx("h3", {
                    className: "text--h3 text--bold text--center mb-3",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.supportedPlatforms))
                }),
                /*#__PURE__*/ _jsx("p", {
                    className: "text--paragraph text--muted text--center",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.intros.supportedPlatforms))
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.platforms,
                    children: this.platforms.map((platform)=>this.renderSupportedPlatform(platform))
                })
            ]
        });
    }
    constructor(props, context){
        super(props);
        this.bls = context.bls;
    }
}
_define_property(SupportedPlatforms, "contextType", AppContext);
_define_property(SupportedPlatforms, "propTypes", {
    identityProviders: PropTypes.arrayOf(shapes.identityProvider),
    localizationResources: PropTypes.object
});
const mapStateToProps = (state)=>({
        identityProviders: selectors.identityProviders(state),
        localizationResources: App.selectors.localizationResources(state)
    });
const ConnectedSupportedPlatforms = connect(mapStateToProps)(SupportedPlatforms);
export default withStyles(styles)(ConnectedSupportedPlatforms);
